import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import CreateItemForm from './CreateItemForm'
// code written by akash -> Akash.ak@stackerbee.com
function ItemCreate() {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
                <title>Item - Create</title>
            </Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <CreateItemForm />
            </div>
        </div>


    )
}

export default ItemCreate
